import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import VueTyperPlugin from 'vue-typer'


Vue.use(Vuetify);
Vue.use(VueTyperPlugin)

export default new Vuetify({
    theme: { dark: true },
    themes: {
        options:{customProperties: true},
        dark: {
          background:'#FF0000',
          primary: '#4caf50',
          secondary: '#ff8c00',
          accent: '#9c27b0'
        }
      }
});
